
import React, { useState } from 'react';
import { Plus, ChevronDown, Users, Home, FileText } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { DS } from '../../lib/design-system';
import { useClickOutside } from '../../hooks/useClickOutside';

interface ActionMenuProps {
    onActionClick: (actionId: string) => void;
}

export const ActionMenu: React.FC<ActionMenuProps> = ({ onActionClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useClickOutside<HTMLDivElement>(() => setIsOpen(false));

  const actions = [
    { id: 'reunion', label: 'Reunión', icon: Users, color: 'text-[#5D1828]', bg: 'bg-[#5D1828]/10', border: 'hover:border-[#5D1828]/30', hover: 'hover:bg-[#5D1828]/10' },
    { id: 'propuesta', label: 'Propuesta', icon: Home, color: 'text-[#B89658]', bg: 'bg-[#B89658]/10', border: 'hover:border-[#B89658]/30', hover: 'hover:bg-[#B89658]/10' },
    { id: 'gestion', label: 'Gestión', icon: FileText, color: 'text-[#B89658]', bg: 'bg-[#B89658]/10', border: 'hover:border-[#B89658]/30', hover: 'hover:bg-[#B89658]/10' },
  ];

  return (
    <div className="relative" ref={menuRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-5 py-2.5 bg-[#5D1828] hover:bg-[#7A2235] text-white rounded-xl transition-all shadow-lg shadow-[#5D1828]/30 font-medium text-sm group ${isOpen ? 'ring-2 ring-[#B89658] ring-offset-1' : ''}`}
      >
        <Plus size={18} strokeWidth={2.5} className={`transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} />
        <span>Nuevo</span>
        <ChevronDown size={14} className={`opacity-60 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            {...DS.animations.dropdown}
            className="absolute top-full right-0 mt-3 w-48 bg-white rounded-2xl shadow-xl border border-[#D1D5DB] overflow-hidden z-[60] p-1.5"
          >
            <div className="px-2 py-1.5 text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
              Crear nuevo...
            </div>
            {actions.map((action) => (
              <button
                key={action.id}
                onClick={() => {
                    setIsOpen(false);
                    onActionClick(action.id);
                }}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all border border-transparent ${action.hover} ${action.border} group relative`}
              >
                <div className={`p-1.5 rounded-lg ${action.bg} ${action.color} transition-colors`}>
                  <action.icon size={16} strokeWidth={2.5} />
                </div>
                <span className="font-medium text-[#111827] group-hover:text-black">{action.label}</span>
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};